require('./authorizeBizumStep2.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

//@core
const { formatText } = require('core/i18n').i18n;

//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');

//@components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class AuthorizeBizumStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSendTermsAndConditions = this.handleSendTermsAndConditions.bind(this);
        this.handleOnClickIconButton = this.handleOnClickIconButton.bind(this);
    }

    handleSendTermsAndConditions() {
        const { onSendTermsAndConditions, emailBizum } = this.props;
        onSendTermsAndConditions(emailBizum);
    }

    buildSendTermsAndConditionsButton(isFetchingTermsAndConditions, hasBeenSentTermsAndConditions) {
        const textSendTermsAndConditionsButton = formatText("authorizeBizumStep2-textSendTermsAndConditionsButton");
        const loading = hasBeenSentTermsAndConditions ? false : isFetchingTermsAndConditions;
        return (
            <OKButton
                modifier="primary"
                onClick={this.handleSendTermsAndConditions}
                loading={loading}
                customLinkClassName="no-print-out"
            >
                {textSendTermsAndConditionsButton}
            </OKButton>
        );
    }

    handleOnClickIconButton() {
        const { requestProfile, history } = this.props;
        requestProfile(history);
    }

    render() {
        const {
            immStep,
            emailBizum,
        } = this.props;
        const title = formatText("authorizeBizumStep2-title");
        const firstMessage = formatText("authorizeBizumStep2-message1");
        const secondMessage = formatText("authorizeBizumStep2-message2");
        const titleEmail = formatText("authorizeBizumStep2-titleEmail");
        const isFetchingTermsAndConditions = immStep.get('isFetching');
        const hasBeenSentTermsAndConditions = immStep.get('hasBeenSent');
        const buttonSendTermsAndConditions = this.buildSendTermsAndConditionsButton(isFetchingTermsAndConditions, hasBeenSentTermsAndConditions);
        const error = immStep.get('error') && !immStep.get('isFetching') ? formatText('cc_portability-errorSendingMail') : '';
        const termsConditionsSuccess = immStep.get('hasBeenSent') && !immStep.get('error') ? formatText('cc_portability-mailSendSuccessfully') : ''

        return (
            <div className="authorize-bizum-step2 no-print-out">
                <h4 className="wizard-step--vertical__title">{title}</h4>
                <div className="authorize-bizum-step2__content">
                    <div className="authorize-bizum-step2__email-account">
                        <BlockInfo extraClass="authorize-bizum-step2__block-info">
                            <div>
                                <p>{firstMessage}</p>
                            </div>
                        </BlockInfo>
                        <div className="authorize-bizum-step2__email-container">
                            <p className="authorize-bizum-step2__title-email">{titleEmail}</p>
                            <p className="authorize-bizum-step2__email">
                                {emailBizum}
                                <OKButton
                                    modifier="secondary"
                                    size="medium"
                                    onClick={this.handleOnClickIconButton}
                                    customLinkClassName="no-print-out"
                                >
                                    <i className="icon-refrescar" />
                                </OKButton>
                            </p>
                        </div>
                    </div>
                    <div className="authorize-bizum-step2__terms-and-conditions">
                        <BlockInfo extraClass="authorize-bizum-step2__block-info">
                            <div>
                                <p>{secondMessage}</p>
                            </div>
                        </BlockInfo>
                        <div className="authorize-bizum-step2__button-terms-conditions-container">
                            {buttonSendTermsAndConditions}
                            <p className="authorize-bizum-step2__error-mail-refresh">
                                {error}
                                {termsConditionsSuccess}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

AuthorizeBizumStep2.propTypes = {
    immAuthorizeBizum: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    emailBizum: PropTypes.string.isRequired,
    onSendTermsAndConditions: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immProfile: PropTypes.object,
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(AuthorizeBizumStep2);
